import React, { useContext } from "react";
import medContext from "../context/medContext";

function AddedMed() {
  const context = useContext(medContext);
  const { med, setMed } = context;
  const deleteMedicine = (med_id) => {
    const updatedMed = med.filter((medicine) => {
      return medicine !== med[med_id];
    });
    setMed(updatedMed);
  };
  return (
    <div className="added-med">
      {med.map((medicine, i) => {
        return (
          <button
            className="btn-med delete"
            key={i}
            onClick={() => {
              deleteMedicine(i);
            }}
          >
            {medicine}
          </button>
        );
      })}
    </div>
  );
}

export default AddedMed;
